import { Paystub } from '@app/models/payroll/paystub.model';
import { Model } from '@models/core/base.model';

export class HourlyPayItem extends Model {
    protected static _resource = 'payroll/companies/:company/payrolls/hourlyPayItems';

    protected static _version = 'v2';

    protected static _serializeAttributes = [
        'name',
        'amount',
        'editable',
        'userModified',
        'hours',
        'multiplier',
        'prorated',
        'prorationDetails',
        'rate',
        'paystubId',
        'compensationId',
    ];

    get paystubId(): number {
        return this._attributes['paystubId'];
    }
    set paystubId(val: number) {
        this._attributes['paystubId'] = val;
    }

    get compensationId(): number {
        return this._attributes['compensationId'];
    }
    set compensationId(val: number) {
        this._attributes['compensationId'] = val;
    }

    get name(): string {
        return this._attributes['name'];
    }

    get hourlyRate(): number {
        return this._attributes['hourlyRate'];
    }

    get amount(): number {
        return Number(this._attributes['amount']);
    }
    get editable(): boolean {
        return this._attributes['editable'];
    }
    get hours(): number {
        return this._attributes['hours'];
    }
    get multiplier(): string {
        return this._attributes['multiplier'];
    }
    get prorated(): boolean {
        return this._attributes['prorated'];
    }
    get prorationDetails(): object {
        return this._attributes['prorationDetails'];
    }
    get rate(): number {
        return Number(this._attributes['rate'] || 0);
    }
    get compensationRate(): number {
        return this._attributes['compensationRate'];
    }
    get compensationUnit(): string {
        return this._attributes['compensationUnit'] || 'Year';
    }
    get compensationVacationPayPercentage(): number {
        return this._attributes['compensationVacationPayPercentage'];
    }

    get compensationEffectiveFrom(): number {
        return this._attributes['compensationEffectiveFrom'];
    }

    get compensationEffectiveTo(): number {
        return this._attributes['compensationEffectiveTo'];
    }

    get canAddOvertime(): boolean {
        return this._attributes['canAddOvertime'];
    }

    get userModified(): boolean {
        return this._attributes['userModified'];
    }

    get startsOrEndsInPayPeriod(): boolean {
        return this._attributes['startsOrEndsInPayPeriod'];
    }

    get employeeHoursExists(): boolean {
        return this._attributes['employeeHoursExists'];
    }

    set name(val: string) {
        this._attributes['name'] = val;
    }
    set amount(val: number) {
        this._attributes['amount'] = val;
    }
    set editable(val: boolean) {
        this._attributes['editable'] = val;
    }
    set hours(val: number) {
        this._attributes['hours'] = val;
    }
    set multiplier(val: string) {
        this._attributes['multiplier'] = val;
    }
    set prorated(val: boolean) {
        this._attributes['prorated'] = val;
    }
    set prorationDetails(val: object) {
        this._attributes['prorationDetails'] = val;
    }
    set rate(val: number) {
        this._attributes['rate'] = val;
    }
    set userModified(val: boolean) {
        this._attributes['userModified'] = val;
    }

    get paystub(): Paystub {
        return this.hasOne(Paystub, 'paystub');
    }

    toAmount(): number {
        return Number(this.hours) * Number(this.multiplier) * Number(this.rate);
    }
}
